import { createI18n } from 'vue-i18n';
import ptbr from '@/lang/pt-br.json';
import en from '@/lang/en.json';
import es from '@/lang/es.json';

export const i18n = createI18n({
  locale: 'pt',
  allowComposition: true,
  messages: {
    en: en,
    pt: ptbr,
    es: es
  }
});

export default i18n.global;
